import React from "react";
import styles from "./CollageLayout.module.scss";
export type CollageProps = {
    media1: React.ReactNode;
    media2: React.ReactNode;
    media3: React.ReactNode;
    media4: React.ReactNode;
    content: React.ReactNode;
};

export const CollageLayout: React.FC<React.PropsWithChildren<CollageProps>> = ({
    media1,
    media2,
    media3,
    media4,
    content,
}) => {
    return (
        <div className={styles.collage}>
            <div className={styles.media1}>{media1}</div>
            <div className={styles.media2}>{media2}</div>
            <div className={styles.media3}>{media3}</div>
            <div className={styles.media4}>{media4}</div>
            <div className={styles.content}>{content}</div>
        </div>
    );
};
